<template>
  <mobile v-if="gl.isMobile">
    <template #status><slot name="status"></slot></template>
    <template #state><slot name="state"></slot></template>
  </mobile>
  <desktop v-else>
    <template #status><slot name="status"></slot></template>
    <template #state><slot name="state"></slot></template>
  </desktop>
</template>

<script>
import { useGl } from '@store/ts/gl';

// components
import Desktop from './desktop.vue';
import Mobile from './mobile.vue';

export default {
    name: 'cell-status-state',
    components: {
        Mobile,
        Desktop,
    },
    setup() {
        const gl = useGl();
    
        return {
            gl,
        };
    },
};
</script>